import { render } from "./table_detail.vue?vue&type=template&id=c4e82c94&scoped=true"
import script from "./table_detail.vue?vue&type=script&lang=js"
export * from "./table_detail.vue?vue&type=script&lang=js"

import "./table_detail.vue?vue&type=style&index=0&id=c4e82c94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e82c94"]])

export default __exports__